import * as React from 'react';
import * as _ from 'lodash';
import { Button, List } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { FormItem } from '../../../../../components/Form';
import CountryStateRow from './components/CountryStateRow';
import CountryStateDetail from './components/CountryStateDetail';

export interface ICountryStatesProps {
  country: GQL.ICountry;
  onChange: Function;
}

export interface ICountryStatesState {
  valueIndex?: any;
}

export default class CountryStates extends React.Component<ICountryStatesProps, ICountryStatesState> {

  public constructor(props: ICountryStatesProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { country } = this.props;

    return (
      <div>
        <FormItem label={'Country states'}>
          <List
            size={'small'}
            bordered={true}
            dataSource={country.states || []}
            renderItem={(countryState: GQL.ICountryState, index: number) => {
              return (
                <List.Item
                  actions={[
                    <Button
                      key={1}
                      danger={true}
                      size={'small'}
                      icon={<DeleteOutlined />}
                      onClick={() => {
                        let states = [...country.states || []];
                        states.splice(index, 1);
                        this.onChange('states', states);
                      }}
                    />
                  ]}
                  key={index}
                  style={{ paddingRight: '8px' }}
                >
                  <CountryStateRow
                    countryState={countryState}
                    onClick={() => this.setState({ valueIndex: index }) }
                  />
                </List.Item>
              );
            }}
          />
          <Button 
            onClick={() => this.setState({ valueIndex: -1 })} 
            style={{ float: 'right', marginTop: 10 }}
          >
            New county / state
          </Button>
        </FormItem>

        {this.state &&
          this.state.valueIndex != undefined && (
            <CountryStateDetail
              countryState={this.getValueForDetail() || {} as GQL.ICountryState}
              onSave={countryState => this.onSaveCountryState(countryState)}
              onCancel={() => this.setState({ valueIndex: undefined })}
            />
          )}
      </div>
    );
  }

  private getValueForDetail() {
    if (this.state.valueIndex !== undefined) {
      if (this.props.country && this.props.country.states) {
        return this.props.country.states[this.state.valueIndex];
      }
    }

    return {} as GQL.ICountryState;
  }

  private onSaveCountryState(countyState: GQL.ICountryState) {
    const country = {...this.props.country};

    // ošetření
    if (!country.states) {
      country.states = [];
    }
    // editace
    if (this.state.valueIndex >= 0) {
      country.states[this.state.valueIndex] = countyState;
    }
    // nový stát
    if (this.state.valueIndex === -1) {
      country.states.push(countyState);
    }

    // setřídění podle názvu
    const states = country.states.sort((a: GQL.ICountryState, b: GQL.ICountryState) => a.name < b.name ? -1 : 0);

    this.props.onChange({
      target: {
        name: 'states',
        value: states
      }
    });

    this.setState({
      valueIndex: undefined,
    });
  }

  private onChange(key: string, val: any) {
    this.props.onChange({
      target: {
        name: key,
        value: val
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Countries/CountryDetail/components/CountryStates/CountryStates.tsx